import {
  call,
  put,
  fork,
  takeEvery,
  take,
  race,
  delay,
} from "redux-saga/effects";
import { socketWriter, socketReader, connectSocket } from "../socket";
import user3 from "./user3";
import locale3 from "./locale3";
import app3 from "./app3";
import view3 from "./view3";
import data3 from "./data3";
import event3 from "./event3";
import form3 from "./form3";
import effect3 from "./effect3";
import {
  INIT_APP3_READY_CLIENT,
  INIT_APP3_READY_SERVER,
  LOAD_LOCALE3,
  LOAD_CONFIGURATION3,
  LOAD_PUBLIC_CONFIGURATION3,
  LOAD_VIEW3,
  LOAD_FORM3,
  DISPATCH_EVENT3,
  SERVER_REQUEST,
  RECONNECT3,
  LOGIN3,
  SAVE_FORM3,
  REQUEST_FORM3_SECTION,
  CHANGE_STATUS3,
  ADD_NOTE3,
  UPLOADv3,
  RUN_EFFECT_V3,
  INIT_UPLOADv3,
  STREAM_UPLOADv3,
  FINISH_UPLOADv3,
  REMOVE_UPLOADv3,
  PUB3_CONFIRM,
  SET_USER_PERSISTENT_PROFILE3,
  REQUEST_CHANGE_STATUS3,
  DOWNLOAD3,
  REFRESH_TOKEN,
  INIT_APP3_SUCCESS,
  CANCEL_LOGIN,
  UNLOAD_FORM3,
  SIGN3,
  COLLECT3,
  SOCKET_DISCONNECT,
  RECONNECT3_SUCCESS,
} from "../constants";
import {
  reconnect3,
  initApp3ReadyClient,
  serverRequest,
  app3Offline,
} from "../actions";

function* handleIO() {
  yield fork(socketReader, window.API_URL);

  const write = socketWriter(window.API_URL);
  yield takeEvery(SERVER_REQUEST, (action) => {
    write(action.payload);
  });
}

/**
 * setupConnection is the first call in appSaga and is responsible for setting up the socket.io connection.
 *
 * When completed it issues INIT_APP3_READY_CLIENT (using initApp3ReadyClient) to continue the init-sequence
 *
 *
 * There is a big difference between admin socket.io and portal socket.io here. In admin we issue
 * the connect once we login, i.e. we rely on REST until we have a logged in user.
 *
 * Word about JWT token: We check if we have a JTW token stored at localStorage. Then we pass that
 * after the connect. If no JWT exist we continoue as anonymous users.
 *
 * NOTE: Portal ALWAYS connect to socket.io, since the portal uses socket.io connection for everything (more or less).
 */
function* setupConnection() {
  /**
   * BREAK? WE REMOVED THE COMMENTS BELOW 2022-06
   *
   * We think it has to do with an old implementation of openId
   */

  // const queryParams = qs.parse(window.location.search.substring(1))

  // if (queryParams.token) {

  //   jwt = queryParams.token
  //   localStorage.setItem('_jwt', queryParams.token)

  //   if (window.history.pushState) {
  //     delete queryParams.token
  //     let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;

  //     if (!isEmpty(queryParams)) {
  //       newurl += '?' + qs.stringify(queryParams)
  //     }
  //     window.history.pushState({ path: newurl }, '', newurl);
  //   }

  // }

  /**
   * BREAK? WE REMOVED THE COMMENTS BELOW 2022-06
   */

  // step 1: connect the socket (read comments above why this is different from admin)
  const socket = yield call(connectSocket);

  // step 2: init IO (read/writes)
  yield fork(handleIO, socket);

  yield put(initApp3ReadyClient({}));
}

/**
 * Ensure that we have a working connection with the server. This prevent us from sending data when redux and/or socket is not 100% initialized.
 *
 * This will loop forever and wait for either an timeout or a dispatch from the server telling us everything is OK (INIT_APP3_READY_SERVER).
 * The response will go via eventHandler (connected)
 *
 */
function* ensureConnection() {
  while (1) {
    var payload = {
      action: "portal/ensureConnection",
    };
    yield put(serverRequest(payload));

    const { posts } = yield race({
      posts: take(INIT_APP3_READY_SERVER),
      timeout: delay(1000),
    });

    if (posts) {
      return;
    }
  }
}

/**
 * Issue an init application-event to server and fetch needed data.
 *
 * Will fetch various information back (such as HTMLTemplates)
 *
 */
function* initApplication() {
  var payload = {
    action: "portal/initApplication",
  };
  yield put(serverRequest(payload));

  let jwt = localStorage.getItem("_jwt");

  //if (jwt) {
  yield put(reconnect3({ token: jwt }));
  //}
}

function* watchSocketDisconnect() {
  while (true) {
    yield take(SOCKET_DISCONNECT);

    const { reconnected } = yield race({
      timeout: delay(5000),
      reconnected: take(RECONNECT3_SUCCESS),
    });

    if (!reconnected) {
      yield put(app3Offline({ isOffline: true }));
    } else {
      yield put(app3Offline({ isOffline: false }));
    }
  }
}

function* appSaga() {
  // setup connection to server, once connection is established this will dispatch: INIT_APP3_READY_CLIENT
  yield fork(setupConnection);

  // Wait for socket-connection to be established
  yield take(INIT_APP3_READY_CLIENT);

  // STEP: socket-connection is now established and the client has finished its setup

  // ensure that the server also is ready. We do this by pinging the server in ensureConnection and wait for INIT_APP3_READY_SERVER
  yield fork(ensureConnection);

  // wait for server to become ready
  yield take(INIT_APP3_READY_SERVER);

  // STEP: server is now also ready

  // regsiter the sagas that we need to initAPP

  yield takeEvery(RECONNECT3, user3.reconnect3); // Needed to issue reconnect

  // tell server to fetch everything we need to start up the client-side app, i.e. templates. Once done it will issue INIT_APP3_SUCCESS
  yield fork(initApplication);

  // STEP: We are all done with the initalization and the client can start

  yield take(INIT_APP3_SUCCESS);

  /**
   * STEP: The client is ready to recieve actions.
   */
  yield fork(watchSocketDisconnect);
  yield takeEvery(LOGIN3, user3.login3);
  yield takeEvery(COLLECT3, user3.collect3);
  yield takeEvery(SIGN3, user3.sign3);

  yield takeEvery(
    SET_USER_PERSISTENT_PROFILE3,
    user3.setUserPersistentProfile3
  );
  yield takeEvery(REFRESH_TOKEN, user3.refreshToken);
  yield takeEvery(CANCEL_LOGIN, user3.cancelLogin);

  yield takeEvery(LOAD_LOCALE3, locale3.loadLocale3);
  yield takeEvery(LOAD_CONFIGURATION3, app3.loadConfiguration3);
  yield takeEvery(LOAD_PUBLIC_CONFIGURATION3, app3.loadPublicConfiguration3);
  yield takeEvery(LOAD_VIEW3, view3.loadView3);

  yield takeEvery(LOAD_FORM3, form3.loadForm3);
  yield takeEvery(UNLOAD_FORM3, form3.unloadForm3);

  yield takeEvery(SAVE_FORM3, form3.saveForm3);
  yield takeEvery(CHANGE_STATUS3, form3.changeStatus3);
  yield takeEvery(REQUEST_CHANGE_STATUS3, form3.requestChangeStatus3);
  yield takeEvery(REQUEST_FORM3_SECTION, form3.requestForm3Section);
  yield takeEvery(ADD_NOTE3, form3.addNote3);
  yield takeEvery(UPLOADv3, form3.uploadv3);

  yield takeEvery(INIT_UPLOADv3, data3.initUpload3);
  yield takeEvery(STREAM_UPLOADv3, data3.streamUpload3);
  yield takeEvery(FINISH_UPLOADv3, data3.finishUpload3);
  yield takeEvery(REMOVE_UPLOADv3, data3.removeUpload3);
  yield takeEvery(PUB3_CONFIRM, data3.pub3Confirm);
  yield takeEvery(DOWNLOAD3, data3.download3);
  yield takeEvery(DISPATCH_EVENT3, event3.dispatchEvent3);

  // effects
  yield takeEvery(RUN_EFFECT_V3, effect3.runEffect3);
}

export default appSaga;
